import { useEffect } from "react";
import MarqueeBanner from "@/components/MarqueeBanner";
import Navbar from "@/components/Navbar";
import Hero from "@/components/Hero";
import BookingBar from "@/components/BookingBar";
import DistanceStrip from "@/components/DistanceStrip";
import Rooms from "@/components/Rooms";
import Facilities from "@/components/Facilities";
import WhyChoose from "@/components/WhyChoose";
import Gallery from "@/components/Gallery";
import Attractions from "@/components/Attractions";
import Reviews from "@/components/Reviews";
import Contact from "@/components/Contact";
import Footer from "@/components/Footer";
import { EditProvider } from "@/lib/EditContext";

const Home = () => {
  useEffect(() => {
    const els = document.querySelectorAll(".reveal");
    const obs = new IntersectionObserver(
      (entries) => {
        entries.forEach((e) => {
          if (e.isIntersecting) e.target.classList.add("visible");
        });
      },
      { threshold: 0.1 }
    );
    els.forEach((el) => obs.observe(el));
    return () => obs.disconnect();
  }, []);

  return (
    <EditProvider>
      <div className="bg-[#F9F7F3]" data-testid="home-page">
        <MarqueeBanner />
        <Navbar />
        <Hero />
        <BookingBar />
        <DistanceStrip />
        <Rooms />
        <Facilities />
        <Gallery />
        <WhyChoose />
        <Attractions />
        <Reviews />
        <Contact />
        <Footer />
      </div>
    </EditProvider>
  );
};

export default Home;
